function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M20.289 15.5a1 1 0 011.842.78A11 11 0 117.6 1.912a1 1 0 01.8 1.834A9 9 0 1020.289 15.5zM23 12a1 1 0 01-1 1H12a1 1 0 01-1-1V2a1 1 0 011-1 11 11 0 0111 11zm-4.636-6.364A9 9 0 0013 3.056V11h7.944a9 9 0 00-2.58-5.364z"
  }));
}
export default SvgIconReports;